module.exports = __webpack_public_path__ + "static/media/VETTA.9c08684b.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Blog/Corona/VETTA.png
// module id = 439
// module chunks = 0